import { render } from "./g-treeview.vue?vue&type=template&id=07c2b18a&ts=true"
import script from "./g-treeview.vue?vue&type=script&lang=tsx"
export * from "./g-treeview.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__